import React, {Component, Fragment} from 'react';
import {Button, Card, CardBody, CardTitle, Row} from 'reactstrap';
import ReactTableTextFilter from '../../../components/ReactTableTextFilter';
import ReactTableSelectFilter from "../../../components/ReactTableSelectFilter";
import {Colxx, Separator} from "../../../components/common/CustomBootstrap";
import ModalManager from "../../../components/modal/ModalManager";
import BonusCardDetails from "../../../containers/BonusCardDetails";
import Breadcrumb from "../../../containers/navs/Breadcrumb";
import LoaderButton from "../../../components/LoaderButton";
import {reactTableText} from '../../../constants/configs';
import UserInfo from "../../../components/UserInfo";
import {i18nizeDate} from '../../../helpers/Utils';
import {keyBy, mapValues, omit} from "lodash";
import {withTranslation} from 'react-i18next';
import Rbac from "../../../components/Rbac";
import Api from "../../../services/Api";
import ReactTable from 'react-table';

class List extends Component {
  constructor(props) {
    super(props);
    this.state = {
      bonusCards: [],
      pages: -1,
      loading: false,
      updating: {},
      expanded: {},
    };
    this.renderUsersFilter = this.renderUsersFilter.bind(this);
    this.renderStatusFilter = this.renderStatusFilter.bind(this);
    this.renderTypeFilter = this.renderTypeFilter.bind(this);
    this.renderAssignTypeFilter = this.renderAssignTypeFilter.bind(this);
  }

  fetchData = async state => {
    try {
      this.setState({loading: true});
      const offset = state.page * state.pageSize;
      const {data} = await Api.invoke(
        'GET',
        '/v2/admin-ui/bonusPolicies',
        null,
        {
          params: {
            offset,
            limit: state.pageSize,
            ...(state.filtered.length ? omit(mapValues(keyBy(state.filtered, 'id'), 'value'), 'createdAt') : null),
          }
        });
      this.setState({
        bonusCards: data.rows,
        pages: Math.ceil(data.count / state.pageSize),
      });
    } catch (e) {
      console.log('error: ', e);
    } finally {
      this.setState({
        loading: false,
      });
    }
  };

  updateBonusPolicy = async (id, values) => {
    this.setState(({updating}) => ({
      updating: {
        ...updating,
        [id]: true,
      },
    }));
    try {
      await Api.invoke('PATCH', `/v2/admin-ui/bonusPolicies/${id}`, values);
      await this.fetchData(this.table.state);
    } catch (e) {
      console.log('error: ', e);
    } finally {
      this.setState(({updating}) => ({
        updating: {
          ...updating,
          [id]: false,
        },
      }));
    }
  }

  onPressStop = (id, code, values) => {
    const {t} = this.props;
    ModalManager.open({
      isOpen: true,
      title: t('Confirm Stop'),
      body: t('Are you sure you want to stop bonus card with code {{code}} ?', {
        code,
      }),
      buttons: [
        {
          color: 'primary',
          onClick: async () => {
            await this.updateBonusPolicy(id, values);
            ModalManager.close({
              isOpen: false
            });
          },
          text: t('Accept'),
        },
        {
          color: 'grey',
          onClick: () => {
            ModalManager.close({
              isOpen: false
            });
          },
          text: t('Close'),
        },
      ],
    });
  };

  getColumns = t => [
    {
      Header: t('Name'),
      accessor: 'name',
      filterable: true,
      Filter: ReactTableTextFilter,
      width: 200,
    },
    {
      Header: t('Bonus Code'),
      accessor: 'code',
      filterable: true,
      Filter: ReactTableTextFilter,
      width: 120,
    },
    {
      Header: t('Bonus Type'),
      accessor: 'effectObject',
      filterable: true,
      Filter: this.renderTypeFilter,
      minWidth: 140,
    },
    {
      Header: t('Assign Type'),
      accessor: 'assignType',
      filterable: true,
      Filter: this.renderAssignTypeFilter,
      Cell: props => <span>{props.value || "MANUAL"}</span>,
      width: 140,
    },
    {
      Header: t('Recipient Type'),
      accessor: 'recipient.type',
      width: 120,
    },
    {
      Header: t('Recipient'),
      accessor: 'recipient',
      Cell: props => {
        const {type, value} = props.value;
        if (type === "USER") {
          return (
            <UserInfo
              onClick={() => {this.props.history.push('/dashboard/users/' + value);}}
              textColor="text-success"
              label={t('User')}
              type={type}
              id={value}
            />
          );
        }
        return <span>{value || "ALL_USERS"}</span>;
      },
      width: 120,
    },
    // {
    //   Header: t('Creator'),
    //   accessor: 'creator.value',
    //   Cell: props => {
    //     return (
    //       <UserInfo
    //         textColor="text-dark"
    //         label={t('Admin')}
    //         id={props.value}
    //         type="ADMIN"
    //       />
    //     );
    //   }
    // },
    {
      Header: t('Bonus Policy'),
      accessor: 'effectFunction.name',
      width: 120,
    },
    {
      Header: t('Status'),
      accessor: 'status',
      filterable: true,
      Filter: this.renderStatusFilter,
      width: 100,
    },
    {
      Header: t('Registration Date'),
      accessor: 'createTime',
      Cell: props => <span>{i18nizeDate(props.value)}</span>,
      width: 130,
    },
    {
      Header: t('End Date'),
      accessor: 'endTime',
      Cell: props => <span>{props.value ? i18nizeDate(props.value) : "---------"}</span>,
      width: 130,
    },
    {
      Header: t('Actions'),
      accessor: 'status',
      width: 220,
      Cell: props => <div className="d-flex flex-row align-items-center">
        {props.value === "STARTED" &&
          <Rbac permission='update_bonus-policy'>
            <LoaderButton
              outline
              size="sm"
              color="danger"
              loading={!!this.state.updating[props.original.id]}
              onClick={async () => {
                await this.onPressStop(
                  props.original.id,
                  props.original.code,
                  {status: 'STOPPED'}
                );
              }}
              className="text-center mr-2">
              {t('Stop')}
            </LoaderButton>
          </Rbac>
        }
        <Button
          outline
          size="sm"
          color="success"
          onClick={() => {
            this.props.history.push('/dashboard/bonusCards/' + props.original.id, {
              createTime: props.original.createTime,
              endTime: props.original.endTime,
            });
          }}
          className="text-center">
          {t('View Stats')}
        </Button>
      </div>,
    },
  ];

  renderUsersFilter({filter, onChange}) {
    const {t} = this.props;
    const options = [
      {value: '', label: t('all')},
      {value: 'USER', label: t('USER')},
      {value: 'GROUP', label: t('GROUP')},
    ];
    return <ReactTableSelectFilter
      filter={filter}
      onChange={onChange}
      options={options}
    />;
  }

  renderStatusFilter({filter, onChange}) {
    const {t} = this.props;
    const options = [
      {value: '', label: t('all')},
      {value: 'CREATED', label: t('CREATED')},
      {value: 'STARTED', label: t('STARTED')},
      {value: 'STOPPED', label: t('STOPPED')},
      {value: 'EXPIRED', label: t('EXPIRED')},
    ];
    return <ReactTableSelectFilter
      filter={filter}
      onChange={onChange}
      options={options}
    />;
  }

  renderTypeFilter({filter, onChange}) {
    const {t} = this.props;
    const options = [
      {value: '', label: t('all')},
      {value: 'REFERRAL', label: t('REFERRAL')},
      {value: 'MAX_REFERRAL', label: t('MAX_REFERRAL')},
      {value: 'TRADE_FEE', label: t('TRADE_FEE')},
    ];
    return <ReactTableSelectFilter
      filter={filter}
      onChange={onChange}
      options={[
        {value: '', label: t('all')},
        ...options,
      ]}
    />;
  }

  renderAssignTypeFilter({filter, onChange}) {
    const {t} = this.props;
    const options = [
      {value: '', label: t('all')},
      {value: 'AUTO', label: 'AUTO'},
      {value: 'MANUAL', label: 'MANUAL'},
    ];
    return <ReactTableSelectFilter
      filter={filter}
      onChange={onChange}
      options={[
        {value: '', label: t('all')},
        ...options,
      ]}
    />;
  }

  handleDateChange = (type, date) => {
    this.setState({
      [type]: date,
    });
  };

  onPressCreate = () => {
    this.props.history.push('/dashboard/bonusCards/create');
  };

  onExpanded = (newExpanded, index) => {
    this.setState({
      expanded: {
        ...this.state.expanded,
        [index[0]]: !!newExpanded[index[0]],
      },
    });
  };

  render() {
    const {t, match} = this.props;
    return (
      <Fragment>
        <Row>
          <Colxx xxs="12">
            <Breadcrumb match={match}/>
            <Separator className="mb-5"/>
          </Colxx>
        </Row>
        <Row>
          <Colxx xxs="12" className="mb-4">
            <Card className="h-100">
              <CardBody>
                <CardTitle className="text-large text-primary d-flex flex-row justify-content-end align-items-center mt-4">
                  <Rbac permission='create_bonus-policy'>
                    <Button onClick={this.onPressCreate}>
                      <i className="simple-icon-plus add-reply-icon"/>
                      <span className="mx-1">{t('Create Bonus Card')}</span>
                    </Button>
                  </Rbac>
                </CardTitle>
                <ReactTable
                  manual
                  ref={el => {this.table = el;}}
                  className="-highlight"
                  data={this.state.bonusCards}
                  pages={this.state.pages}
                  loading={this.state.loading}
                  sortable={false}
                  resizable={true}
                  onFetchData={this.fetchData}
                  columns={this.getColumns(t)}
                  onExpandedChange={this.onExpanded}
                  expanded={this.state.expanded}
                  defaultPageSize={25}
                  style={{
                    width: '100%'
                  }}
                  {...reactTableText}
                  SubComponent={({original}) => <BonusCardDetails bonusCard={original} />}
                />
              </CardBody>
            </Card>
          </Colxx>
        </Row>
      </Fragment>
    );
  }
}

export default withTranslation()(List);
